define('widgets/casumo2/viewmodel',[
    'knockout'
], function (ko) {
    var Casumo = function (casumos) {
        var self = this;

        self.belt = ko.observable(0);
        self.percentage = ko.observable(0);

        self.casumo = ko.pureComputed(function () {
            return casumos.getCasumoByBelt('belt-' + self.belt());
        });

    };

    Casumo.prototype.activate = function (settings) {
        var self = this;

        self.belt = settings.belt;
        self.percentage = settings.percentage;
    };

    return Casumo;
});

